export default __webpack_public_path__ + "static/sentrydefault_320x180-734588d91c316bdff68ca906c03c9d76.jpg";